import {
  COMPONENT_VALUE_TYPES as types,
} from 'shared/constants';
import type { PropsSchemaList } from 'shared/types/PropsSchema';

const propsSchema: PropsSchemaList = [
  {
    key: 'imageConfig',
    label: 'Image Configuration',
    type: types.OBJECT,
    children: [
      {
        key: 'firstImageUrl',
        label: 'First Image URL',
        type: types.TEXT,
      },
      {
        key: 'imageCount',
        label: 'Image Count',
        type: types.TEXT,
      },
      {
        key: 'containerHeight',
        label: 'Container Height',
        tooltip: 'A smaller container height results in images transitioning faster while scrolling.',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'videoConfig',
    label: 'Video Configuration',
    type: types.OBJECT,
    children: [
      {
        key: 'videoUrl',
        label: 'Video URL',
        type: types.TEXT,
      },
      {
        key: 'containerHeight',
        label: 'Container Height',
        tooltip: 'This height should be greater than the video height. It provides some buffer space which prevents \
        the video from moving off-screen if the user accidentally scrolls after the image-to-video transition.',
        type: types.TEXT,
      },
    ]
  },
  {
    key: 'mobileParallax',
    label: 'Show Parallax on mobile (default: show video only)',
    type: types.BOOLEAN
  }
];

const defaultProps = {
  imageConfig: {
    firstImageUrl: 'https://genesis-cdn.ff.com/assets/pages/ff-91/techluxury_parallax/2104_Head_jpeg/2104_Head_00000.jpg',
    imageCount: 36,
    containerHeight: 4000
  },
  videoConfig: {
    videoUrl: 'https://genesis-cdn.ff.com/assets/pages/ff-91/techluxury_parallax/2104_CustomWebMaster_03A_headless_Web.mp4',
    containerHeight: 1000
  },
  mobileParallax: false
};

export default {
  title: 'Video Parallax',
  id: 'VideoParallax',
  propsSchema,
  defaultProps
};
